import type { RentalOrder } from '@super-mega/server/contracts/order'
import type { RentalFormValues } from '../rental-form.types.ts'
import type { RentalRoomRow, RentalSiteRow } from '../rental-resource-selector-modals.tsx'
import { rentalEnterprisePayload } from './order-enterprise-selection.ts'

export function buildRentalPayload({
  values,
  selectedSite,
  selectedRoom,
  existingOrder,
  latestOrder
}: {
  values: RentalFormValues
  selectedSite: RentalSiteRow
  selectedRoom?: RentalRoomRow
  existingOrder?: RentalOrder
  latestOrder?: RentalOrder
}) {
  let orderGroup: { mode: 'existing'; id: number | undefined } | { mode: 'new'; name: string | undefined } | undefined
  if (values.orderGroupMode === 'existing') {
    orderGroup = { mode: 'existing', id: values.orderGroupId }
  } else if (values.orderGroupMode === 'new') {
    orderGroup = { mode: 'new', name: values.orderGroupName?.trim() || undefined }
  }
  return {
    agreedPrice: values.agreedPrice,
    ...rentalEnterprisePayload(
      existingOrder && existingOrder.customerId !== values.customerId ? undefined : latestOrder,
      values.enterpriseSelection
    ),
    addressSnapshot: {
      ...(existingOrder?.addressSnapshot && typeof existingOrder.addressSnapshot === 'object'
        ? existingOrder.addressSnapshot
        : {}),
      cityName: selectedSite.cityName,
      detailAddress: selectedSite.detailAddress,
      districtName: selectedSite.districtName,
      organizationId: selectedSite.organization?.id ?? null,
      organizationName: selectedSite.organization?.name ?? null,
      provinceName: selectedSite.provinceName,
      roomId: selectedRoom?.id ?? null,
      roomNo: selectedRoom?.roomNo ?? null,
      siteId: selectedSite.id,
      siteName: selectedSite.name
    },
    billingInterval: values.billingInterval,
    businessId: values.businessId,
    contractPartyKind: values.contractPartyKind,
    contractPartyName: values.contractPartyName?.trim() || undefined,
    contractSettings: values.contractSettings,
    contractTemplateId:
      values.contractSettings === undefined
        ? values.contractTemplateId
        : (values.contractSettings[0]?.templateId ?? null),
    contractType: values.contractSettings?.[0]?.contractType ?? values.contractType,
    customerId: values.customerId,
    depositAmount: values.depositAmount ?? null,
    managementFee: values.managementFee ?? null,
    electricityUnitPrice: values.electricityUnitPrice,
    endAt: values.period[1].format('YYYY-MM-DD'),
    fileIds: values.fileIds,
    leaseAction: values.leaseAction,
    note: values.note?.trim() || undefined,
    occupancyMode: values.occupancyMode,
    orderGroup,
    pricingTerms: {
      ...(existingOrder?.pricingTerms && typeof existingOrder.pricingTerms === 'object'
        ? existingOrder.pricingTerms
        : {}),
      electricityUnitPrice: values.electricityUnitPrice ?? null,
      waterUnitPrice: values.waterUnitPrice ?? null
    },
    referencePrice: values.referencePrice,
    rentType: values.rentType,
    services: values.includeServices
      ? values.items.map(({ enterpriseSelection: _selection, subjectId: _subject, ...item }) => item)
      : undefined,
    salespersonId: values.salespersonId,
    roomId: values.roomId,
    siteId: values.siteId,
    startAt: values.period[0].format('YYYY-MM-DD'),
    waterUnitPrice: values.waterUnitPrice
  }
}
